<template>
<div class="collapse navbar-collapse" id="collapsibleNavbar">
    
    <ul class="navbar-nav mr-auto" v-if="guest">
        
            <li class="nav-item" >
                <router-link class="nav-link" to="/dashboard/central">Inicio</router-link>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Embarcaciones</a>
            </li>
            <li class="nav-item">
                <router-link to="/dashboard/question">Despacho</router-link>
            </li> 
    </ul>
    
    <ul class="navbar-nav mr-auto" v-if="uumm">
        
        <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/password">Cambio de Contraseña</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="" class="nav-link dropdown-toggle" id="navbarDropShip" data-toggle="dropdown">
                    <font-awesome-icon icon="anchor" size="lg" /> Embarcaciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/update-owner">Administracion de Personas u Empresas</router-link>
                    <router-link class="dropdown-item" to="/dashboard/register-port">Puertos/Muelles</router-link>
                    <router-link class="dropdown-item" to="/dashboard/register-empresa-vias">Empresas y Autorizaciones</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-list-empresa">Reporte de Empresas</router-link>
                    <router-link class="dropdown-item" to="/dashboard/uumm-sign">Certificados Empresas y Embarcaciones</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-list-vencidos-uumm">Reportes Empresas y Naves</router-link>
                    <!-- <router-link class="dropdown-item" to="/dashboard/change-owner">Impresion de Certificados</router-link> -->
                </div>
            </li> 
    </ul>

    <ul class="navbar-nav mr-auto" v-if="supadmin">
            <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>       

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/password">Cambio de Contraseña</router-link>                    
                    <router-link class="dropdown-item" to="/dashboard/users">Administracion de Usuarios</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ufv-config">Configuracion UFV</router-link>
                    <router-link class="dropdown-item" to="/dashboard/firm-director">Datos Director</router-link>
                    <router-link class="dropdown-item" to="/dashboard/register-charge">Registro de Carga</router-link>
                    <router-link class="dropdown-item" to="/dashboard/add-unit-captain">Añadir Unidades o Capitanias</router-link>
                </div>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="anchor" size="lg" /> Capitanias
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/register-capitan">Capitanes de Puerto</router-link>
                    <router-link class="dropdown-item" to="/dashboard/persons-captain">Personal Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/uuss">Unidades de Superficie</router-link>
                    <router-link class="dropdown-item" to="/dashboard/engine">Motores</router-link>
                    <router-link class="dropdown-item" to="/dashboard/services-captain">Servicios</router-link>
                    <router-link class="dropdown-item" to="/dashboard/captain-location">Geolocalizacion de Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/jurisdiccion-captain">Jurisdiccion Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/photo-captain">Fotografias Capitania</router-link>
                    <router-link class="dropdown-item" to="/dashboard/river-lake">Configuracion Rios</router-link>
                    <router-link class="dropdown-item" to="/dashboard/task-captain">Tareas Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/inforapadmin">Reportes/Novedades</router-link>
                </div>
            </li>

            <li class="nav-item dropdown">
                <a href="" class="nav-link dropdown-toggle" id="navbarDropShip" data-toggle="dropdown">
                    <font-awesome-icon icon="ship" size="lg" /> Embarcaciones
                </a>
                <div class="dropdown-menu">
                    
                    <router-link class="dropdown-item" to="/dashboard/update-owner">Administracion de Personas u Empresas</router-link>
                    <router-link class="dropdown-item" to="/dashboard/change-owner">Cambio de Propietario</router-link>
                    <router-link class="dropdown-item" to="/dashboard/pasavante-options">Pasavantes </router-link>

                    <router-link class="dropdown-item" to="/dashboard/reprint-doc-ship">Registros de Nave</router-link>

                    <router-link class="dropdown-item" to="/dashboard/upload-ship">Subir Fotografia Nave</router-link>
                    <router-link class="dropdown-item" to="/dashboard/approved-enrollment">Aprobacion Matriculas</router-link>
                    <router-link class="dropdown-item" to="/dashboard/order-print">Orden Impresion Matricula</router-link>
                    <router-link class="dropdown-item" to="/dashboard/resume-ship">Resumen de Embarcaciones</router-link>
                    <router-link class="dropdown-item" to="/dashboard/down-ship">Baja de Embarcacion</router-link>
                </div>
            </li>
            
            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="clipboard-list" size="lg" /> Operaciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/verify-enrollment">Validez de Matricula</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-op">Orden de Operacion</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-location">Localizacion ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopnexo">Ordop Anexos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopapprovemilla">Aprobacion Millas</router-link>
                    <router-link class="dropdown-item" to="/dashboard/denounces-police">Denuncias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/river-read">Lectura Nivel Rio</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="" class="nav-link dropdown-toggle" id="navbarDropShip" data-toggle="dropdown">
                    <font-awesome-icon icon="coins" size="lg" /> DAF
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/discharge">Descargos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/conf-budget">Configuracion Partidas</router-link>    
                    <router-link class="dropdown-item" to="/dashboard/conf-ceiling">Asignacion Presupuestaria</router-link>    
                    <router-link class="dropdown-item" to="/dashboard/exec-budget">Ejecucion Presupuestaria</router-link>    
                </div>
            </li>
            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="file-pdf" size="lg" /> Reportes
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/reprint-doc">Reimpresion Documentos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-pending">Reporte Pendientes Descargo</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-budget">Presupuestos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-ingress">Reporte Ingresos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-details">Detalles Ordop</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-op-r">Reportes ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-res">Cuadro ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-charts">Graficos ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopositive">Geolocalizacion de Ordops</router-link>
                    <router-link class="dropdown-item" to="/dashboard/captain-table">Matriz Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/location-captains">Mapa Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopmapvigent">Mapa Ordop en Ejecución</router-link>
                    <router-link class="dropdown-item" to="/dashboard/table-resume-ccpp">Resumen CCPP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/juris-captains">Jurisdiccion Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/print-enrollment">Impresion de Matricula</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river">Reporte Niveles de Rio</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river-diario">Niveles de Rio Diario</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-certificate"> Certificaciones Ordop</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reporte-ine"> INE</router-link>
                </div>
            </li>     

    </ul>

    <ul class="navbar-nav mr-auto" v-if="admin">
            <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>       

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/password">Cambio de Contraseña</router-link>
                    <router-link class="dropdown-item" to="/dashboard/register-capitan">Capitanes de Puerto</router-link>
                    <!-- <router-link class="dropdown-item" to="/dashboard/users">Administracion de Usuarios</router-link> -->
                </div>
            </li>     

            <li class="nav-item dropdown">
                <a href="" class="nav-link dropdown-toggle" id="navbarDropShip" data-toggle="dropdown">
                    <font-awesome-icon icon="anchor" size="lg" /> Embarcaciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/approved-enrollment">Aprobacion Matriculas</router-link>
                    <router-link class="dropdown-item" to="/dashboard/order-print">Orden Impresion Matricula</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-op">Orden de Operacion</router-link>
                    <router-link class="dropdown-item" to="/dashboard/pasavante-options">Pasavantes </router-link>
                    <router-link class="dropdown-item" to="/dashboard/resume-ship">Resumen de Embarcaciones</router-link>
                </div>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="clipboard-list" size="lg" /> Operaciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/ord-op">Orden de Operacion</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-location">Localizacion ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopnexo">Ordop Anexos</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="file-pdf" size="lg" /> Reportes
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/reprint-doc">Reimpresion Documentos</router-link>
                    <!-- <router-link class="dropdown-item" to="/dashboard/reprint-discharge">Reimpresion de Descargos</router-link> -->
                    <!-- <router-link class="dropdown-item" to="/dashboard/report-ingress">Reporte Ingresos</router-link> -->
                    <router-link class="dropdown-item" to="/dashboard/report-budget">Presupuestos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-res">Cuadro ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-details">Detalles Ordop</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-charts">Graficos ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/captain-table">Matriz Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopositive">Geolocalizacion Resultado de Ordops</router-link>                    
                    <router-link class="dropdown-item" to="/dashboard/ordopmapvigent">Mapa Ordop en Ejecución</router-link>
                    <router-link class="dropdown-item" to="/dashboard/juris-captains">Jurisdiccion Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-op-r">Reportes ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/location-captains">Mapa Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river">Reporte Niveles de Rio</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river-diario">Niveles de Rio Diario</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reporte-ine"> INE</router-link>
                </div>
            </li>     

    </ul>

    <ul class="navbar-nav mr-auto" v-if="oper">        
            <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/register-capitan">Capitanes de Puerto</router-link>
                    <router-link class="dropdown-item" to="/dashboard/password">Cambio de Contraseña</router-link>
                    <router-link class="dropdown-item" to="/dashboard/users">Registro de Personal</router-link>
                    <router-link class="dropdown-item" to="/dashboard/persons-captain">Personal Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/uuss">Unidades de Superficie</router-link>
                    <router-link class="dropdown-item" to="/dashboard/engine">Motores</router-link>
                    <router-link class="dropdown-item" to="/dashboard/services-captain">Servicios</router-link>
                    <router-link class="dropdown-item" to="/dashboard/photo-captain">Fotografias Capitania</router-link>
                    <router-link class="dropdown-item" to="/dashboard/transfer-access">Transferir Acceso</router-link>
                    
                </div>  
            </li>     
            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="anchor" size="lg" /> Capitanias
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/river-read">Lectura Nivel Rio</router-link>
                    <router-link class="dropdown-item" to="/dashboard/inforap">Novedades/Reportes</router-link>
                </div>
            </li>
            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="ship" size="lg" /> Embarcaciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/update-owner">Administracion de Personas u Empresas</router-link>
                    <router-link class="dropdown-item" to="/dashboard/change-owner">Cambio de Propietario(Transferencia)</router-link>
                    <router-link class="dropdown-item" to="/dashboard/rectification/updateShip">Cambiar Datos Nave(Modificacion)</router-link>
                    <router-link class="dropdown-item" to="/dashboard/renew-ship">Renovacion</router-link>
                    <!-- <router-link class="dropdown-item" to="/dashboard/pasavante-options">Pasavantes </router-link> -->
                    <router-link class="dropdown-item" to="/dashboard/question">Despacho Naves(Zarpe/Atraque)</router-link>
                    <router-link class="dropdown-item" to="/dashboard/enrollment">Nueva Solicitud Matriculacion(Nuevas)</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reprint-doc-ship">Registros de Nave (Historico)</router-link>
                    <router-link class="dropdown-item" to="/dashboard/rectification/rectifi">Rectificacion Datos</router-link>                    
                    <router-link class="dropdown-item" to="/dashboard/upload-ship">Subir Fotografia Nave</router-link>
                    <router-link class="dropdown-item" to="/dashboard/enrollment-direct">Registro Embarcaciones Existentes(Antiguas)</router-link>
                    <router-link class="dropdown-item" to="/dashboard/resume-ship">Resumen de Embarcaciones</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="clipboard-list" size="lg" /> Operaciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/verify-enrollment">Validez de Matricula</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-op">Orden de Operacion</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-location">Localizacion ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopnexo">Ordop Anexos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/denounces-police">Denuncias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/uumm-sign">Registro Asignacion</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="file-signature" size="lg" /> Sanciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/not-register-sancion">NO Solicitar Despacho</router-link>
                    <router-link class="dropdown-item" to="/dashboard/penalty">Contravenciones</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="coins" size="lg" /> DAF
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/discharge">Descargo por ingresos</router-link>
                </div>  
            </li>

            <!-- reportes ORDOP -->
            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="file-pdf" size="lg" /> Reportes
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/report-pending">Reporte Pendientes Descargo</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reprint-discharge">Reimpresion de Descargos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reprint-doc">Reimpresion Documentos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/print-enrollment">Impresion de Matricula</router-link>
                    <router-link class="dropdown-item" to="/dashboard/juris-captains">Jurisdiccion Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-op-r">Reportes ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-details">Detalles Ordop</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-res">Cuadro ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-charts">Graficos ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopositive">Geolocalizacion de Ordops</router-link>
                    <router-link class="dropdown-item" to="/dashboard/captain-table">Matriz Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/location-captains">Mapa Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river">Reporte Niveles de Rio</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reporte-ine"> INE</router-link>
                </div>  
            </li>            
    </ul>

    <ul class="navbar-nav mr-auto" v-if="security">        
            <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/password">Cambio de Contraseña</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="anchor" size="lg" /> Capitanias
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/register-capitan">Capitanes de Puerto</router-link>
                    <router-link class="dropdown-item" to="/dashboard/captain-location">Geolocalizacion de Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/jurisdiccion-captain">Jurisdiccion Capitanias</router-link>
                </div>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="clipboard-list" size="lg" /> Operaciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/verify-enrollment">Validez de Matricula</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-op">Orden de Operacion</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-location">Localizacion ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopnexo">Ordop Anexos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopapprovemilla">Aprobacion Millas</router-link>
                    <router-link class="dropdown-item" to="/dashboard/denounces-police">Denuncias</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="file-signature" size="lg" /> Sanciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/not-register-sancion">NO Solicitar Despacho</router-link>
                    <router-link class="dropdown-item" to="/dashboard/penalty">Contravenciones</router-link>
                </div>  
            </li>

            <!-- reportes ORDOP -->
            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="file-pdf" size="lg" /> Reportes
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/juris-captains">Jurisdiccion Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-op-r">Reportes ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-details">Detalles Ordop</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-res">Cuadro ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-charts">Graficos ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopositive">Geolocalizacion de Ordops</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopmapvigent">Mapa Ordop en Ejecución</router-link>
                    <router-link class="dropdown-item" to="/dashboard/captain-table">Matriz Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/location-captains">Mapa Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river">Reporte Niveles de Rio</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river-diario">Niveles de Rio Diario</router-link>
                    <router-link class="dropdown-item" to="/dashboard/table-resume-ccpp">Resumen CCPP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reporte-ine"> INE</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordop-certificate"> Certificaciones Ordop</router-link>
                </div>  
            </li>            
    </ul>

    <ul class="navbar-nav mr-auto" v-if="enrollment">        
            <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/password">Cambio de Contraseña</router-link>
                    <router-link class="dropdown-item" to="/dashboard/firm-director">Datos Director</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="" class="nav-link dropdown-toggle" id="navbarDropShip" data-toggle="dropdown">
                    <font-awesome-icon icon="anchor" size="lg" /> Embarcaciones
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/approved-enrollment">Aprobacion Matriculas</router-link>
                    <router-link class="dropdown-item" to="/dashboard/order-print">Orden Impresion Matricula</router-link>
                    <router-link class="dropdown-item" to="/dashboard/rectification/rectifi">Rectificacion Datos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/upload-ship">Subir Fotografia Nave</router-link>
                    <router-link class="dropdown-item" to="/dashboard/enrollment-direct">Registro Embarcaciones Existentes</router-link>
                    <router-link class="dropdown-item" to="/dashboard/resume-ship">Resumen de Embarcaciones</router-link>
                    <router-link class="dropdown-item" to="/dashboard/down-ship">Baja de Embarcacion</router-link>
                    <router-link class="dropdown-item" to="/dashboard/pasavante-options">Pasavantes </router-link>
                    <router-link class="dropdown-item" to="/dashboard/enrollment-direct">Registro Embarcaciones Existentes(Antiguas/Pasavantes)</router-link>
                </div>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="clipboard-list" size="lg" /> Operaciones
                </a>
                <div class="dropdown-menu">                 
                    <router-link class="dropdown-item" to="/dashboard/verify-enrollment">Validez de Matricula</router-link>
                </div>  
            </li>
             <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="file-pdf" size="lg" /> Reportes
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/captain-table">Matriz Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/location-captains">Mapa Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/juris-captains">Jurisdiccion Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ordopositive">Geolocalizacion de Ordops</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river">Reporte Niveles de Rio</router-link>
                    <router-link class="dropdown-item" to="/dashboard/table-resume-ccpp">Resumen CCPP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reporte-ine"> INE</router-link>
                </div>
            </li>     
    </ul>

    <ul class="navbar-nav mr-auto" v-if="finance">        
            <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/ufv-config">Configuracion UFV</router-link>
                    <router-link class="dropdown-item" to="/dashboard/password">Cambio de Contraseña</router-link>
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="coins" size="lg" /> DAF
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/discharge">Descargo por ingresos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/conf-budget">Configuracion Partidas</router-link>    
                    <router-link class="dropdown-item" to="/dashboard/conf-ceiling">Asignacion Presupuestaria</router-link>    
                    <router-link class="dropdown-item" to="/dashboard/exec-budget">Ejecucion Presupuestaria</router-link>    
                </div>  
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="file-pdf" size="lg" /> Reportes
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/report-budget">Presupuestos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-ingress">Reporte Ingresos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-budget">Reportes Ejecucion Presupuestaria</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-pending">Reporte Pendientes Descargo</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reprint-discharge">Reimpresion de Descargos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reprint-doc">Reimpresion Documentos</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reporte-ine"> INE</router-link>
                </div>  
            </li>            
    </ul>

    <ul class="navbar-nav mr-auto" v-if="capitanias">
            <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>       

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/register-capitan">Capitanes de Puerto</router-link>
                    <router-link class="dropdown-item" to="/dashboard/users">Administracion de Usuarios</router-link>
                    <router-link class="dropdown-item" to="/dashboard/persons-captain">Personal Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/uuss">Unidades de Superficie</router-link>
                    <router-link class="dropdown-item" to="/dashboard/engine">Motores</router-link>
                    <router-link class="dropdown-item" to="/dashboard/services-captain">Servicios</router-link>
                    <router-link class="dropdown-item" to="/dashboard/photo-captain">Fotografias Capitania</router-link>
                    <router-link class="dropdown-item" to="/dashboard/captain-location">Geolocalizacion de Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/jurisdiccion-captain">Jurisdiccion Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/river-lake">Configuracion Rios</router-link>
                    <router-link class="dropdown-item" to="/dashboard/inforapadmin">Reportes/Novedades</router-link>
                    <!-- <router-link class="dropdown-item" to="/dashboard/users">Administracion de Usuarios</router-link> -->
                </div>
            </li>
            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="ship" size="lg" /> Reportes
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/captain-table">Matriz Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/location-captains">Mapa Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/juris-captains">Jurisdiccion Capitanias</router-link>
                    <router-link class="dropdown-item" to="/dashboard/ord-op-r">Reportes ORDOP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river">Reporte Niveles de Rio</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-river-diario">Niveles de Rio Diario</router-link>
                    <router-link class="dropdown-item" to="/dashboard/table-resume-ccpp">Resumen CCPP</router-link>
                    <router-link class="dropdown-item" to="/dashboard/report-list-vencidos-uumm">Reportes Empresas y Naves UUMM</router-link>
                    <router-link class="dropdown-item" to="/dashboard/reporte-ine"> INE</router-link>
                </div>
            </li>
    </ul>


    <div class="mt-2 mt-md-0">
        <button class="btn" :class="dangerTime ? 'btn-outline-danger':'btn-outline-success' " @click="mIncrement" > {{ time }} <font-awesome-icon icon="sync-alt" :spin="animate_increment" /> </button>
        <button class="btn btn-outline-primary my-2 my-sm-0" @click="logout"><font-awesome-icon icon="door-open" size="lg" /> Salir</button>
    </div>

</div>
</template>

<script>
import Vue from 'vue';

export default {
    name:'nav-bar',
    props:{
        guest:Boolean,
        admin:Boolean, 
        oper:Boolean,
        security:Boolean,
        finance:Boolean,
        supadmin:Boolean,
        enrollment:Boolean,
        capitanias:Boolean,
        uumm:Boolean
    },
    mounted(){
        this.mTimeSession()
    },
    data(){
        return {
            time:null,
            dangerTime:false,
            animate_increment:false
        }
    },
    methods:{
        logout(){
            this.$auth.destroyToken();
            this.$router.push('/auth/login');
            this.$store.dispatch('sessionDestroy',true);
        },
        mTimeSession(){
            
            setInterval(()=>{
                let endToken=localStorage.getItem('authTokenExpiration');
                let timeActually=Date.now();
                let diff=parseInt(endToken)-parseInt(timeActually);
                let min = Math.floor((diff/1000/60) << 0);
                let sec = Math.floor((diff/1000) % 60);
                if(min>0){
                    this.time=`${min + ':' + sec}`;
                }else{
                    this.time=`00:00`;
                }                
                
                if(min<12){
                    this.dangerTime=true;
                }else{
                    this.dangerTime=false;
                }
                // console.log(this.time);
            },1000)
        },
        mIncrement(){
            this.animate_increment=true;
            // console.log('aumentando');
            let endTk=localStorage.getItem('authTokenExpiration');
            let timeActually=Date.now();
            let diff2=parseInt(endTk)-parseInt(timeActually);
            let min = Math.floor((diff2/1000/60) << 0);
            if(min<200){
                let neT=parseInt(endTk)+1800000;
                localStorage.removeItem('authTokenExpiration');
                localStorage.setItem('authTokenExpiration', neT);
            }else{
                toastr.info('Aun cuenta con tiempo suficiente, intentelo dentro 30 min.', 'Advertencia');
            }
            setTimeout(()=>{
                this.animate_increment=false;
            }, 5000)
            // this.$auth.setToken(res.data[0].user[0].api_token, neT, res.data[0].user[0].category,res.data[0].user[0].role );
        }
    },
    computed:{
        cUserSession(){
            // console.log(this.$store.getters.getUserState);
            return this.$store.getters.getUserState;           
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Navbar.vue